import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import Btn from '../framework/buttons/btn';
import Clickable from '../framework/clickable';

const BodyListItem = ({ groups, marker_id, subtitle, title }) => {
	const id_key = `marker-item-${marker_id}`;

	return (
		<Clickable id={id_key}>
			<Btn
				className="clickable py-3 rounded-3"
				color="light"
				component="group_link"
				footnote={subtitle}
				fullWidth
				groups={groups}
				labelType="h3"
				marker_id={marker_id}
				page="kroppen"
				removePill
				rightSection={<ArrowRightShort className="thumb-sm" />}
				size="md"
				variant="thumb_btn"
				withThumb
			>
				{title}
			</Btn>
		</Clickable>
	);
};

BodyListItem.propTypes = {
	excerpt: PropTypes.string,
	groups: PropTypes.array,
	marker_id: PropTypes.number,
	size: PropTypes.string,
	subtitle: PropTypes.string,
	title: PropTypes.string,
};

export default BodyListItem;
